const enNav = {
  companyPlans: 'Company Plans',
  companies: 'Companies',
  planPurchases: 'Plan Purchases',
  companyEntitlements: 'Company Entitlements',
  companyCodeBatches: 'Code Batches',
  companyAccessCodes: 'Access Codes',
  sponsoredAssessments: 'Sponsored Assessments',
};

const arNav = {
  companyPlans: 'خطط الشركات',
  companies: 'الشركات',
  planPurchases: 'مشتريات الخطط',
  companyEntitlements: 'استحقاقات الشركات',
  companyCodeBatches: 'دفعات الرموز',
  companyAccessCodes: 'رموز الوصول',
  sponsoredAssessments: 'التقييمات الممولة',
};

const enActions = {
  suspend: 'Suspend',
  resume: 'Resume',
  revoke: 'Revoke',
  confirmPayment: 'Confirm payment',
};

const arActions = {
  suspend: 'تعليق',
  resume: 'استئناف',
  revoke: 'إلغاء',
  confirmPayment: 'تأكيد الدفع',
};

const enEmpty = {
  plans: 'No company plans match the current filters.',
  companies: 'No companies match the current filters.',
  purchases: 'No plan purchases match the current filters.',
  entitlements: 'No entitlements match the current filters.',
  codeBatches: 'No access-code batches match the current filters.',
  accessCodes: 'No access codes match the current filters.',
  sponsoredAssessments: 'No sponsored assessments match the current filters.',
};

const arEmpty = {
  plans: 'لا توجد خطط شركات مطابقة للتصفية الحالية.',
  companies: 'لا توجد شركات مطابقة للتصفية الحالية.',
  purchases: 'لا توجد مشتريات مطابقة للتصفية الحالية.',
  entitlements: 'لا توجد استحقاقات مطابقة للتصفية الحالية.',
  codeBatches: 'لا توجد دفعات رموز مطابقة للتصفية الحالية.',
  accessCodes: 'لا توجد رموز وصول مطابقة للتصفية الحالية.',
  sponsoredAssessments: 'لا توجد تقييمات ممولة مطابقة للتصفية الحالية.',
};

const enCatalog = {
  group: 'Company Plans',
  plansTitle: 'Company plans',
  planCreate: 'New plan',
  planEdit: 'Edit plan',
  planDetail: 'Plan detail',
  companiesTitle: 'Companies',
  companyDetail: 'Company detail',
  purchasesTitle: 'Plan purchases',
  purchaseDetail: 'Purchase detail',
  entitlementsTitle: 'Company entitlements',
  entitlementDetail: 'Entitlement detail',
  batchesTitle: 'Access-code batches',
  batchDetail: 'Batch detail',
  codesTitle: 'Access codes',
  codeDetail: 'Access code',
  sponsoredTitle: 'Sponsored assessments',
  sponsoredResult: 'Sponsored result',
  futurePurchasesWarning: 'Editing this plan changes the catalog for future purchases only. Historical paid snapshots stay immutable.',
  archiveInstead: 'This plan has historical purchases, so it cannot be deleted. Archive or deactivate it instead.',
  archiveConfirm: 'Archive this plan so it cannot be purchased in the future? Existing paid entitlements are unchanged.',
  deleteConfirm: 'Delete this plan? This is only allowed when no historical purchases exist.',
  activatePlan: 'Activate plan',
  deactivatePlan: 'Deactivate plan',
  nameAr: 'Arabic name',
  nameEn: 'English name',
  descriptionAr: 'Arabic description',
  descriptionEn: 'English description',
  attempts: 'Included assessment attempts',
  price: 'Price',
  currency: 'Currency',
  validityDays: 'Validity days',
  validityDaysHint: 'Optional. Leave empty for no expiry.',
  active: 'Active',
  featured: 'Featured',
  sortOrder: 'Sort order',
  purchasesCount: 'Historical purchases',
  companyName: 'Company',
  owner: 'Owner',
  members: 'Members',
  status: 'Status',
  purchases: 'Purchases',
  activeEntitlements: 'Active entitlements',
  creditTotals: 'Credit totals',
  generatedCodes: 'Generated codes',
  claimedCodes: 'Claimed codes',
  completedSponsored: 'Completed sponsored assessments',
  legalName: 'Legal name',
  displayName: 'Display name',
  suspendCompany: 'Suspend company',
  activateCompany: 'Activate company',
  suspendCompanyBody: 'Suspending a company prevents new access-code generation and redemption according to Laravel rules. Completed result snapshots are not rewritten.',
  activateCompanyBody: 'Activate this company so members can generate and redeem codes again, subject to Laravel entitlement rules.',
  role: 'Role',
  snapshot: 'Immutable plan snapshot',
  attemptQuantity: 'Attempt quantity',
  paymentStatus: 'Payment status',
  paymentProvider: 'Payment provider',
  paymentReference: 'Provider / manual reference',
  transactionReference: 'Transaction reference',
  adminNote: 'Administrative note',
  paymentEvents: 'Payment events',
  entitlementCreated: 'Entitlement created',
  createdAt: 'Created',
  paidAt: 'Paid',
  confirmPaymentTitle: 'Confirm manual payment',
  confirmPaymentBody: 'Laravel remains the payment authority. Confirming records the administrator reference and note. This dashboard never marks a purchase paid locally.',
  confirmPaymentSubmit: 'Record confirmation',
  dateFrom: 'From',
  dateTo: 'To',
  totalCredits: 'Total credits',
  availableCredits: 'Available credits',
  reservedCredits: 'Reserved credits',
  consumedCredits: 'Claimed / consumed credits',
  validityPeriod: 'Validity period',
  suspendEntitlement: 'Suspend entitlement',
  resumeEntitlement: 'Resume entitlement',
  revokeEntitlement: 'Revoke entitlement',
  suspendEntitlementBody: 'Laravel will stop new code operations for this entitlement. Existing completed snapshots stay unchanged.',
  resumeEntitlementBody: 'Ask Laravel to resume this entitlement if the current status allows it.',
  revokeEntitlementBody: 'Revoking is a Laravel-owned transition. Unused credits will no longer be available.',
  batchLabel: 'Batch label',
  assessmentVersion: 'Assessment version',
  maskedCode: 'Masked code',
  claimingParticipant: 'Claiming participant',
  attempt: 'Attempt',
  completedAt: 'Completed',
  expiresAt: 'Expires',
  participant: 'Participant',
  revokeCode: 'Revoke code',
  revokeCodeBody: 'Revoke this unused active code? Claimed and completed codes cannot be revoked because they already consume credit or have a result snapshot.',
  participantName: 'Participant full name',
  batchOrCode: 'Batch / code',
  attemptStatus: 'Attempt status',
  profileCode: 'Profile code',
  startedAt: 'Started',
  consent: 'Consent',
  consentAt: 'Consent timestamp',
  consentVersion: 'Consent version',
  sponsoringCompany: 'Sponsoring company',
  hero: 'Hero',
  rankedPatterns: 'Ranked Professional Patterns',
  topPatterns: 'Top patterns',
  personalSummary: 'Personal Summary',
  keyStrengths: 'Key Strengths',
  growthOpportunities: 'Growth Opportunities',
  careerPaths: 'Career Paths',
  skillsAdvice: 'Skills and advice',
  orderedItems: 'Globally ordered result items',
  noResult: 'Laravel did not return a user-facing result for this sponsored attempt.',
  validation: {
    attempts: 'Included attempts must be a positive integer.',
    price: 'Enter a valid decimal price that matches the currency minor-unit scale.',
    currency: 'Select a supported currency.',
    validityDays: 'Validity days must be a positive integer when provided.',
    sortOrder: 'Sort order must be zero or a positive integer.',
    paymentReference: 'A transaction reference is required.',
    adminNote: 'An administrative note is required.',
  },
  statuses: {
    pending_payment: 'Pending payment',
    paid: 'Paid',
    failed: 'Failed',
    cancelled: 'Cancelled',
    refunded: 'Refunded',
    active: 'Active',
    exhausted: 'Exhausted',
    expired: 'Expired',
    suspended: 'Suspended',
    revoked: 'Revoked',
    claimed: 'Claimed',
    completed: 'Completed',
    featured: 'Featured',
    inactive: 'Inactive',
    in_progress: 'In progress',
  },
  roles: {
    owner: 'Owner',
    manager: 'Manager',
    viewer: 'Viewer',
  },
  providers: {
    manual: 'Manual',
  },
  codes: {
    cannotRevoke: 'This code cannot be revoked.',
    cannotRevokeClaimed: 'Claimed codes cannot be revoked because they already reserve or consume a credit.',
    cannotRevokeCompleted: 'Completed codes cannot be revoked because the sponsored result snapshot already exists.',
    cannotRevokeExpired: 'Expired codes cannot be revoked.',
    alreadyRevoked: 'This code is already revoked.',
    inspectOnly: 'Company members generate codes on the website. This dashboard inspects and administers them.',
    maskedOnly: 'Full access codes are hidden unless Laravel explicitly permits revelation.',
  },
};

const arCatalog = {
  group: 'خطط الشركات',
  plansTitle: 'خطط الشركات',
  planCreate: 'خطة جديدة',
  planEdit: 'تعديل الخطة',
  planDetail: 'تفاصيل الخطة',
  companiesTitle: 'الشركات',
  companyDetail: 'تفاصيل الشركة',
  purchasesTitle: 'مشتريات الخطط',
  purchaseDetail: 'تفاصيل المشترى',
  entitlementsTitle: 'استحقاقات الشركات',
  entitlementDetail: 'تفاصيل الاستحقاق',
  batchesTitle: 'دفعات رموز الوصول',
  batchDetail: 'تفاصيل الدفعة',
  codesTitle: 'رموز الوصول',
  codeDetail: 'رمز الوصول',
  sponsoredTitle: 'التقييمات الممولة',
  sponsoredResult: 'نتيجة التقييم الممول',
  futurePurchasesWarning: 'تعديل هذه الخطة يؤثر على المشتريات المستقبلية فقط. اللقطات المدفوعة السابقة تبقى ثابتة.',
  archiveInstead: 'لهذه الخطة مشتريات سابقة، لذلك لا يمكن حذفها. استخدم الأرشفة أو إلغاء التفعيل.',
  archiveConfirm: 'أرشفة هذه الخطة حتى لا تُشترى مستقبلاً؟ الاستحقاقات المدفوعة الحالية لن تتغير.',
  deleteConfirm: 'حذف هذه الخطة؟ يُسمح بذلك فقط عند عدم وجود مشتريات سابقة.',
  activatePlan: 'تفعيل الخطة',
  deactivatePlan: 'إيقاف الخطة',
  nameAr: 'الاسم بالعربية',
  nameEn: 'الاسم بالإنجليزية',
  descriptionAr: 'الوصف بالعربية',
  descriptionEn: 'الوصف بالإنجليزية',
  attempts: 'محاولات التقييم المشمولة',
  price: 'السعر',
  currency: 'العملة',
  validityDays: 'أيام الصلاحية',
  validityDaysHint: 'اختياري. اتركه فارغاً إذا لم يكن هناك انتهاء.',
  active: 'نشطة',
  featured: 'مميزة',
  sortOrder: 'ترتيب العرض',
  purchasesCount: 'المشتريات السابقة',
  companyName: 'الشركة',
  owner: 'المالك',
  members: 'الأعضاء',
  status: 'الحالة',
  purchases: 'المشتريات',
  activeEntitlements: 'الاستحقاقات النشطة',
  creditTotals: 'إجمالي الأرصدة',
  generatedCodes: 'الرموز المُنشأة',
  claimedCodes: 'الرموز المُستخدمة',
  completedSponsored: 'التقييمات الممولة المكتملة',
  legalName: 'الاسم القانوني',
  displayName: 'اسم العرض',
  suspendCompany: 'تعليق الشركة',
  activateCompany: 'تفعيل الشركة',
  suspendCompanyBody: 'تعليق الشركة يمنع إنشاء رموز وصول جديدة واستردادها وفق قواعد Laravel. لقطات النتائج المكتملة لا تُعاد كتابتها.',
  activateCompanyBody: 'تفعيل الشركة يسمح للأعضاء بإنشاء الرموز واستردادها مرة أخرى وفق قواعد الاستحقاق في Laravel.',
  role: 'الدور',
  snapshot: 'لقطة الخطة الثابتة',
  attemptQuantity: 'عدد المحاولات',
  paymentStatus: 'حالة الدفع',
  paymentProvider: 'مزود الدفع',
  paymentReference: 'مرجع المزود / اليدوي',
  transactionReference: 'مرجع العملية',
  adminNote: 'ملاحظة إدارية',
  paymentEvents: 'أحداث الدفع',
  entitlementCreated: 'تم إنشاء الاستحقاق',
  createdAt: 'تاريخ الإنشاء',
  paidAt: 'تاريخ الدفع',
  confirmPaymentTitle: 'تأكيد الدفع اليدوي',
  confirmPaymentBody: 'Laravel هو مرجع الدفع. التأكيد يسجّل مرجع المسؤول والملاحظة. لوحة التحكم لا تُعلّم المشترى مدفوعاً محلياً.',
  confirmPaymentSubmit: 'تسجيل التأكيد',
  dateFrom: 'من',
  dateTo: 'إلى',
  totalCredits: 'إجمالي الأرصدة',
  availableCredits: 'الأرصدة المتاحة',
  reservedCredits: 'الأرصدة المحجوزة',
  consumedCredits: 'الأرصدة المطالب بها / المستهلكة',
  validityPeriod: 'فترة الصلاحية',
  suspendEntitlement: 'تعليق الاستحقاق',
  resumeEntitlement: 'استئناف الاستحقاق',
  revokeEntitlement: 'إلغاء الاستحقاق',
  suspendEntitlementBody: 'سيتوقف Laravel عن عمليات الرموز الجديدة لهذا الاستحقاق. اللقطات المكتملة تبقى كما هي.',
  resumeEntitlementBody: 'طلب استئناف هذا الاستحقاق من Laravel إذا كانت الحالة تسمح بذلك.',
  revokeEntitlementBody: 'الإلغاء انتقال يملكه Laravel. الأرصدة غير المستخدمة لن تبقى متاحة.',
  batchLabel: 'تسمية الدفعة',
  assessmentVersion: 'إصدار التقييم',
  maskedCode: 'الرمز المقنّع',
  claimingParticipant: 'المشارك المطالب',
  attempt: 'المحاولة',
  completedAt: 'تاريخ الإكمال',
  expiresAt: 'تاريخ الانتهاء',
  participant: 'المشارك',
  revokeCode: 'إلغاء الرمز',
  revokeCodeBody: 'إلغاء هذا الرمز النشط غير المستخدم؟ لا يمكن إلغاء الرموز المطالب بها أو المكتملة لأنها استهلكت رصيداً أو أنشأت لقطة نتيجة.',
  participantName: 'الاسم الكامل للمشارك',
  batchOrCode: 'الدفعة / الرمز',
  attemptStatus: 'حالة المحاولة',
  profileCode: 'رمز الملف',
  startedAt: 'تاريخ البدء',
  consent: 'الموافقة',
  consentAt: 'وقت الموافقة',
  consentVersion: 'إصدار الموافقة',
  sponsoringCompany: 'الشركة الراعية',
  hero: 'المقدمة',
  rankedPatterns: 'الأنماط المهنية المرتبة',
  topPatterns: 'أعلى الأنماط',
  personalSummary: 'الملخص الشخصي',
  keyStrengths: 'نقاط القوة',
  growthOpportunities: 'فرص النمو',
  careerPaths: 'المسارات المهنية',
  skillsAdvice: 'المهارات والنصيحة',
  orderedItems: 'عناصر النتيجة بالترتيب العام',
  noResult: 'لم يُرجع Laravel نتيجة موجّهة للمستخدم لهذه المحاولة الممولة.',
  validation: {
    attempts: 'يجب أن يكون عدد المحاولات عدداً صحيحاً موجباً.',
    price: 'أدخل سعراً عشرياً صالحاً يطابق مقياس الوحدة الصغرى للعملة.',
    currency: 'اختر عملة مدعومة.',
    validityDays: 'يجب أن تكون أيام الصلاحية عدداً صحيحاً موجباً عند إدخالها.',
    sortOrder: 'يجب أن يكون ترتيب العرض صفراً أو عدداً صحيحاً موجباً.',
    paymentReference: 'مرجع العملية مطلوب.',
    adminNote: 'الملاحظة الإدارية مطلوبة.',
  },
  statuses: {
    pending_payment: 'بانتظار الدفع',
    paid: 'مدفوع',
    failed: 'فشل',
    cancelled: 'ملغى',
    refunded: 'مسترد',
    active: 'نشط',
    exhausted: 'مستنفد',
    expired: 'منتهٍ',
    suspended: 'معلّق',
    revoked: 'ملغى',
    claimed: 'مطالب به',
    completed: 'مكتمل',
    featured: 'مميز',
    inactive: 'غير نشط',
    in_progress: 'قيد التنفيذ',
  },
  roles: {
    owner: 'مالك',
    manager: 'مدير',
    viewer: 'مشاهد',
  },
  providers: {
    manual: 'يدوي',
  },
  codes: {
    cannotRevoke: 'لا يمكن إلغاء هذا الرمز.',
    cannotRevokeClaimed: 'لا يمكن إلغاء الرموز المطالب بها لأنها حجزت أو استهلكت رصيداً.',
    cannotRevokeCompleted: 'لا يمكن إلغاء الرموز المكتملة لأن لقطة النتيجة الممولة موجودة.',
    cannotRevokeExpired: 'لا يمكن إلغاء الرموز المنتهية.',
    alreadyRevoked: 'هذا الرمز ملغى مسبقاً.',
    inspectOnly: 'ينشئ أعضاء الشركة الرموز من الموقع. هذه اللوحة تفحصها وتديرها.',
    maskedOnly: 'تبقى الرموز الكاملة مخفية ما لم يسمح Laravel بالكشف عنها صراحة.',
  },
};

export function applyCompanyPlanMessages(base) {
  return {
    en: {
      ...base.en,
      nav: {
        ...base.en.nav,
        ...enNav,
        groups: {
          ...base.en.nav.groups,
          companyPlans: 'Company Plans',
        },
      },
      actions: { ...base.en.actions, ...enActions },
      empty: { ...base.en.empty, ...enEmpty },
      companyPlans: enCatalog,
    },
    ar: {
      ...base.ar,
      nav: {
        ...base.ar.nav,
        ...arNav,
        groups: {
          ...base.ar.nav.groups,
          companyPlans: 'خطط الشركات',
        },
      },
      actions: { ...base.ar.actions, ...arActions },
      empty: { ...base.ar.empty, ...arEmpty },
      companyPlans: arCatalog,
    },
  };
}
